/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Access = {
  APLICATION: 388,
  BROKER_SENIOR_APPROVAL: '417',
  PERSON_EDIT: '457',
  CREATE_FRAMEWORK: '460',
  PERSON_EDIT_GOVERNMENT: '620',

  ENQUIRY: {
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY: 429,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,

  },

  APPROVE_REJECT_POLICY_PACK: {
    READ: 413,
    APPROVE_REJECT_INTERNALLY: 414,
    APPROVE_REJECT_CLIENT: 415,
    GENERATE_WORDING: 416,
    POLICY_PACK_SEND_INTERNALLY: 418,
    POLICY_PACK_SEND_INSURER: 419,
    POLICY_PACK_SEND_CLIENT: 420,
  },

  SEND_POLICY_PACK_INTERNALLY: {
    READ: 388,
    SEND: 388,
  },

  MARKET_SELECTION: {
    SELECT_MARKETS: 434,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    MARKETS_SELECTION_RESEND: 438,
    MARKETS_SELECTION_ANSWER_AS_INSURER: 439,
  },

  APPROVAL_NBI: {
    NBI_SEND_APPROVAL: 440,
    NBI_APPROVE_REJECT: 441,
  },

  MARKET_COMPOSITION: {
    MARKETING_COMPOSITION: 442,
    GENERATE_WORDING: 416,
    GENERATE_MRC: 427,
    MARKETING_COMPOSITION_SAVE: 443,
    EXPORT_SCHEDULE: 444,
    IMPORT_SCHEDULE: 445,
    MARKETS_SELECTION: 436,
  },

  ORDER_TO_BIND: {
    ORDER_TO_BIND_GENERATE: 421,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    EXECUTION_SEND: 423,
    MARKETING_COMPOSITION: 442,
  },

  STAMPS_REQUEST: {
    EXECUTION: 446,
    EXECUTION_SEND: 423,
    ENDORSEMENT_PACK_SEND_DIRECTOR_APPROVAL: 475,
  },

  PAYMENT_PACK: {
    PAYMENT_PACK_SEND_INTERNALLY: 425,
    PAYMENT_PACK_SEND_EXTERNALLY: 426,
    PAYMENT_PACK_READ: 447,
    PAYMENT_PACK_CREATE: 424,
    EXPORT_SCHEDULE: 444,
    IMPORT_SCHEDULE: 445,
  },

  SEND_WORDING: {
    MARKETING_COMPOSITION: 442,
    GENERATE_MRC: 427,
  },

  SCHEDULE: {
    IMPORT_SCHEDULE: 445,
  },

  ENDORSEMENTS: {
    ENDORSEMENT_PACK_APPROVE_REJECT: 465,
    ENDORSEMENT_PACK_APPROVE_REJECT_INTERNALLY: 466,
    ENDORSEMENT_PACK_APPROVE_REJECT_CLIENT: 467,
    ENDORSEMENT_PACK_SEND_INTERNALLY: 468,
    ENDORSEMENT_PACK_SEND_CLIENT: 470,
    ENDORSEMENT_PACK_SEND_INSURER: 469,
  },

  POLICIES: {
    POLICIES_CREATE_ENDORSEMENT: 476,
    POLICIES_EDIT: 477,
  },

  PAYMENTS: {
    PAYMENTS_IMPORT_OSND: 471,
    PAYMENTS_EXPORT_PAYMENTS: 472,
    PAYMENTS_CHANGE_STATUS: 473,
    PAYMENTS_COMMENTS: 474,
    PAYMENTS_CHANGE_ABORTED: 577,
    PAYMENTS_EXPORT_REPORTS: 639
  },

  MANAGEMENT: {
    MANAGEMENT_ACCESS: 462
  },
  PROCESS_ADMIN: {
    PROCESS_ADMIN_ACCESS: 457
  }
};

export default Access;
